const state = {
    points: {},
    lastPoint: null,
    errorPointsSignature: false
}

const mutations = {
    SetSignaturePoints(state, points) {
        state.points = points;
    },
    ErrorSetSignaturePoints(state, boolError) {
        state.errorPointsSignature = boolError;
        alert("errorPointsSignature = " + state.errorPointsSignature);
    } 
}

const actions = {

}

const getters = {
    GetSignaturePoints(state) { return state.points },
    ErrorGetSignaturePoints(state) { return state.errorPointsSignature }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
